export class ContactUsDto {
  fullName: string;
  email: string;
  phone: string;
  subject: string;
  message: string;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/data/contact-us-dto.ts